import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild} from '@angular/core';
import {Image} from "../../interfaces/image";
import {RoughHeadlineService} from "../../shared/rough-headline/rough-headline.service";
import {ScrollTriggerService} from "../../services/scroll-trigger.service";

@Component({
  selector: 'brt-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent implements AfterViewInit, OnDestroy {

  imageViewportSize = '150px';
  private resizeObserver?: ResizeObserver;
  image: Image | null = null;
  srcSet: string = '';
  imageLoaded = false;
  thumbnailSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
  isPlaceholder = false;

  @Output('loaded') loaded = new EventEmitter<void>();

  @ViewChild('imageWrapper') imageWrapperElement!: ElementRef;

  @Input("image") set setImageData(value: Image | null) {

    if(typeof value === 'undefined' || value === null) {
      return;
    }

    this.image = value;

    // Generate srcSet for responsive images
    this.srcSet = `
    ${this.image.portrait.url} ${this.image.portrait.width}w,
    ${this.image.landscape.url} ${this.image.landscape.width}w,
    ${this.image.large.url} ${this.image.large.width}w,
    ${this.image.xlarge.url} ${this.image.xlarge.width}w,
    ${this.image.medium.url} ${this.image.medium.width}w,
    ${this.image.huge.url} ${this.image.huge.width}w`;

    if(this.image.medium.url.indexOf("placeholders") > -1) {
      this.isPlaceholder = true;
    }

  }

  backgroundColors = ['#fbc800', '#2996d2', '#128750'];
  backgroundColor = this.backgroundColors[Math.floor(Math.random() * this.backgroundColors.length)];

  constructor(
    private cdref: ChangeDetectorRef,
    private roughHeadlineService: RoughHeadlineService,
    private scrollTriggerService: ScrollTriggerService
  ) { }

  ngAfterViewInit(): void {
    const width = this.imageWrapperElement.nativeElement.offsetWidth;

    if (width > 0) {
      this.setViewportSize(width);
      return;
    }

    // offsetWidth is 0 when the component starts inside a display:none ancestor.
    // Observe the wrapper and re-measure once it actually gains a layout box (i.e. becomes visible).
    this.resizeObserver = new ResizeObserver(() => {
      const currentWidth = this.imageWrapperElement.nativeElement.offsetWidth;
      if (currentWidth > 0) {
        this.setViewportSize(currentWidth);
        this.resizeObserver?.disconnect();
      }
    });
    this.resizeObserver.observe(this.imageWrapperElement.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  private setViewportSize(width: number): void {
    this.imageViewportSize = width + 'px';
    this.cdref.detectChanges();
  }

  onImageLoaded() {
    this.imageLoaded = true;

    window.requestAnimationFrame(() => {
      this.roughHeadlineService.updateHeadlines();
      this.scrollTriggerService.updateTriggers();
    });

    this.loaded.emit();
  }
}
